import React from 'react';
import {Flex, Text} from '@priority-software/priority-style-react';
import styles from './style.module.scss';
import todolistPromoImg from '../../../images/todolist_promo.png';
import todolistPromoHebImg from '../../../images/todolist_promo_he.png';
import {isRTL} from '../../../Localization';
import texts from '../../ToDoList/texts';

export const TodoListPromoContent = () => {
    return (
        <Flex direction="column">
            <img
                src={isRTL() ? todolistPromoHebImg : todolistPromoImg}
                alt="ToDoList Promo"
                className={styles.todolistPromoImg}
            />
            <Text skin="paragraph-2">{texts.promos_content}</Text>
        </Flex>
    );
};
